import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-indicator-dot',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './indicator-dot.component.html',
  styleUrl: './indicator-dot.component.scss',
})
export class IndicatorDotComponent {
  @Input() isIndicatorSuccess!: boolean;
}
